<template>
    <div class="login">
        <form class="loginForm" @submit.prevent="validateEmail">
            <div class="formTitle">Log In</div>
            <div class="userEmail">
                <Notification class="emailError" v-if="error" :notification-mode="'error'">
                    <template v-slot:title> Invalid Email </template>
                </Notification>
                <label class="fieldLabel">Email</label>
                <div class="fieldBody">
                    <input type="text"
                        v-model.trim="email"
                        placeholder="example@domain.com"
                        class="fieldInput"
                        autocomplete="off"
                        autocapitalize="off"
                        autocorrect="off"
                        maxlength="50"
                        required>
                </div>
            </div>
            <Button :button-type="'submit'"
                    :button-style="'auto'">Log In</Button>
        </form>
    </div>
</template>

<script>
import Button from './shared/Button.vue';
import Notification from './shared/Notification.vue';
import { signIn } from './B2C/authPopup.js';
import { emailRegex } from './shared/constants';

export default {
    components: { Button, Notification },
    data() {
        return {
            authToken: '',
            email: '',
            error: false
        }
    },

    methods: {
        validateEmail() {
            emailRegex.test(this.email) ? this.triggerLoginPopup() : this.error = true;
        },
        triggerLoginPopup() {
            signIn(this.email);
        }
    }
}
</script>

<style lang="scss" scoped>
.login {
   padding-bottom: 144px;
}

.loginForm {
    width: 376px;
    background: $LOGIN-FORM-BG;
    padding: 42px 48px 32px 48px;
    margin: 120px auto auto auto;
    font-size: 14px;
    line-height: 18px;
}

.fieldInput {
    border: 1px solid $LOGIN-INPUT-BORDER;
    font: inherit;
    line-height: 18px;
    padding: 7px;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    &::placeholder {
        color: $LOGIN-INPUT-PLACEHOLDER;
        font-weight: 300;
    }
}

.userEmail {
    margin: 32px auto 24px auto;
    color: $LOGIN-INPUT-NAME;
}

.emailError {
    margin-bottom: 18px;
}

.fieldLabel {
    margin-bottom: 4px;
    font-weight: 500;
    display: block;
}

.fieldBody {
    display: flex;
    height: 32px;
}

.formTitle {
    font-weight: bold;
    color: $LOGIN-TITLE;
    font-size: 21px;
}
</style>